(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }
  customElements.define('cart-note', CartNote);

  function syncTaxifyCartInclusivePrice() {
    const wrapper = document.getElementById('main-cart-footer');
    if (!wrapper) return;

    if (window.Taxify && typeof window.Taxify.rescanAllElements === 'function') {
      try { window.Taxify.rescanAllElements(); } catch (e) {}
    }

    const taxifyInclusive = wrapper.querySelector('.taxify-price--inclusive .taxify-amount');
    const ourPlaceholder = document.getElementById('cart-subtotal-incl-vat-value');
    if (ourPlaceholder && taxifyInclusive) {
      const newVal = taxifyInclusive.textContent.trim();
      if (newVal) {
        ourPlaceholder.innerHTML = '<span class="cart-subtotal-incl-vat-amount">' + newVal + '</span>';
      }
    }
  }

  function scheduleTaxifySync() {
    setTimeout(syncTaxifyCartInclusivePrice, 100);
    setTimeout(syncTaxifyCartInclusivePrice, 600);
    setTimeout(syncTaxifyCartInclusivePrice, 1200);
    setTimeout(syncTaxifyCartInclusivePrice, 2500);
    setTimeout(syncTaxifyCartInclusivePrice, 4000);
  }

  function observeCartSubtotalInclVat() {
    const placeholder = document.getElementById('cart-subtotal-incl-vat-value');
    if (!placeholder || placeholder._taxifyObserving) return;
    placeholder._taxifyObserving = true;
    const observer = new MutationObserver(function() {
      if (placeholder.querySelector('.taxify-price-container')) {
        syncTaxifyCartInclusivePrice();
      }
    });
    observer.observe(placeholder, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function() {
    scheduleTaxifySync();
    observeCartSubtotalInclVat();
  });
  document.addEventListener('cart:item-quantity-update', function() {
    scheduleTaxifySync();
    setTimeout(observeCartSubtotalInclVat, 500);
  });
  document.addEventListener('cart:item-remove', scheduleTaxifySync);
  document.addEventListener('cart:item-add', scheduleTaxifySync);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
      scheduleTaxifySync();
      setTimeout(observeCartSubtotalInclVat, 500);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
